import Backbone from 'backbone'
import template from './upload-revision-step2.hbs'
import _ from 'lodash'
import $ from 'jquery'
import FormView from 'scoreboard/components/form-view'
import i18n from 'scoreboard/components/i18n'
import ToggleAllCheckboxes from 'scoreboard/components/toggle-all-checkboxes'

const RevisionStep2 = Backbone.View.extend({

	tagName: 'form',

	events: {
		'change input[type=checkbox]': 'onCheckboxChange',
		'click .cancel': 'close'
	},

	/**
	 * Step 2 of the revision wizard
	 * After uploading a revision of a managed document, this displays a list
	 * of the imports that are affected by the change, and allows the user
	 * to select which imports should be run
	 *
	 * @constructs
	 *
	 * @param {Object} options
	 *
	 * @param {Document} options.model the document the revision is for
	 */
	initialize: function (options) {
		this.options = options || {}
		this.formView = new FormView({
			el: this.el,
			allowCleanSubmission: true,
			guard: false,
			submit: this.submit.bind(this)
		})
	},

	render: function () {
		this.$el.empty().append(template(this.context()))
		this.options.wizard.render({
			formView: this.formView
		})

		this.toggleAllCheckboxes = new ToggleAllCheckboxes({
			el: this.el
		}).render()

		// #30784 remove 'Back' button
		this.$('.back').remove()
		// and don't allow moving back by clicking on wizard step 1
		this.$('.wizard-progress-bubble[data-step=1]').removeClass('is-navigable')

		this.formView.start()
		return this
	},

	context: function () {
		let imports = _.get(this.model.attributes, 'imports')
		let key = 'documents.revision.imports.message'
		let instructions = i18n.countMessage(key, imports.length)
		return {
			imports,
			instructions
		}
	},

	onCheckboxChange: function () {
		let selected = this.$('[type=checkbox]:checked').not('.select-all').length
		let doneKey = 'documents.revision.imports.run'
		if (selected == 0) {
			doneKey = 'common.done'
		}
		this.$('.button-primary').text(i18n.get(doneKey))
	},

	submit: function () {
		let checked = this.$('[type=checkbox]:checked').not('.select-all')
		let importIds = _.map(checked, function (input) {
			return parseInt(input.value)
		})
		let documentId = this.model.get('id')
		let url = `api/files/${documentId}/run`
		return $.ajax({
			method: 'post',
			url,
			data: JSON.stringify(importIds)
		}).then(() => {
			this.close()
		})
	},

	/**
	 * #30784 Close and trigger the wizard's 'done' event (to refresh the
	 * revisions list) after:
	 * 1. submitting this step or
	 * 2. cancelling out of the wizard, either by using the cancel button or the
	 * escape key (see dialog.js escape())
	 */
	close: function () {
		this.options.wizard.finish(this.model)
		this.trigger('done')
	},

	remove: function () {
		Backbone.View.prototype.remove.apply(this, arguments)
		_.invokeMap([this.toggleAllCheckboxes], 'remove')
	}
})

export default RevisionStep2
RevisionStep2.__filename__ = 'documents/upload-revision-step2.js'
